module.exports = __webpack_public_path__ + "static/media/cp8.e5b1a355.png";